import {ThemeProvider} from "../ThemeProvider";
import {CongratsUpper, CongratsLower, BackgroundImage} from "./congrats/Components.js"
import Footer from "./Footer/Footer.js"
export class IDPThemeProvider implements ThemeProvider {
    CMSPrefix: 'string';
    header = {
        Logo: {
            uri: 'https://antenna.gr/',
            img: <img src="images/idp/ant1-logo136x58.svg"
                      alt="ant1 logo"
                      className="ant1-logo"/>
        }
    }
    Footer = Footer;
    uris = {
        other: {
            termsAndConditions: 'https://help.antennaplus.gr/όροι-χρήσης/'
        }
    }
    congrats = {
        ContentContainerUpper: CongratsUpper,
        ContentContainerLower: CongratsLower,
        BackgroundImage: BackgroundImage,
        primaryCTA: true
    };
}